<template>
  <div style="display:flex; flex-direction:column;justify-content:center; align-items:center;">
    <video id="giftvideo" height="640" width="720" style="display:none;">
      <source :src="giftUrl" type="video/mp4">
    </video>
    <canvas id="tempPlay" width="1440" height="1280" style="display:none"></canvas>
    <canvas id="realPlay" width="720" height="1280" style="flex:0 0 none;height:100%;"></canvas>
  </div>
</template>

<script>
export default {
  name: "VideoGiftPlayer",
  data() {
    return {
      //strGiftUrl: "",
      objBufferCanvas: null,
      objOutputCanvas: null,
      objOutput: null,
      objBuffer: null,
      objVideoControl:null,
      interval : null,
    };
  },
  mounted(){
      this.objBufferCanvas = document.getElementById("tempPlay");
      this.objBuffer = this.objBufferCanvas.getContext("2d");
      //透明数据绘制
      this.objOutputCanvas = document.getElementById("realPlay");
      this.objOutput = this.objOutputCanvas.getContext("2d");

      this.giftvideo = document.getElementById("giftvideo");

      let that = this;
      this.giftvideo.addEventListener(
        "play",
        function() {
          if (that.interval != null) {
            clearInterval(that.interval);
            that.interval = null;
          }
          that.$emit("playState", 1);
          that.interval = setInterval(that.processFrame, 60);
        },
        false
      );
      this.giftvideo.addEventListener(
        "ended",
        function() {
          if (that.interval != null) {
            clearInterval(that.interval);
            that.interval = null;
          }
          that.clearCanvas();
          that.$store.commit("GIFT_UPDATE_BIGGIFTPLAYURL_REMOVE_TOP");
          that.giftvideo.src = ""
          if (that.$store.state.giftData.strBiggiftPlayUrlList.length == 0) {
            that.$emit("playState", 0);
          }else{
            that.playGiftVideo();
          }
        },
        false
      );
  },
  computed: {
    giftUrl() {
      if (this.$store.state.giftData.strBiggiftPlayUrlList.length > 0) {
        return this.$store.state.giftData.strBiggiftPlayUrlList[0];
      }else{
        return "";
      }
    }
  },
  watch: {
    // giftUrl(newValue, oldValue) {
    //   if (oldValue == "") {
    //     this.playGiftVideo();
    //   }
    // }
  },
  methods: {
    //call this function from father component
    addPalyTask(url){
      this.$store.commit('GIFT_ADD_BIGGIFTPLAYURL', url);
      if (this.$store.state.giftData.strBiggiftPlayUrlList.length > 1) {
        console.log(this.$store.state.giftData.strBiggiftPlayUrlList);
        return 
      }
      this.playGiftVideo();
    },
    //all these function is for self call
    playGiftVideo() {
      //this.strGiftUrl = url;
      //全视频绘制
      this.giftvideo.src = this.giftUrl;
      this.giftvideo.play();

    },
    processFrame() {
      
      this.$emit("playState", 2);
      let width = this.objOutputCanvas.width;
      let height = this.objOutputCanvas.height;
      this.objBuffer.drawImage(this.giftvideo, 0, 0);

      let maskObj = this.objBuffer.getImageData(0, 0, width, height);
      let maskData = maskObj.data;
      let realObj = this.objBuffer.getImageData(width, 0, width, height);
      let realData = realObj.data;

      for (let i = 3, len = maskData.length; i < len; i += 4) {
        realData[i] = maskData[i - 1];
      }
      // putImageData() 将图像数据放回画布：
      this.objOutput.putImageData(realObj, 0, 0);
    },
    clearCanvas() {
      let tempPlay = document.getElementById("tempPlay");
      let realPlay = document.getElementById("realPlay");
      let cxtTemp = tempPlay.getContext("2d");
      let cxtReal = realPlay.getContext("2d");
      cxtTemp.clearRect(0, 0, tempPlay.width, tempPlay.height);
      cxtReal.clearRect(0, 0, realPlay.width, realPlay.height);
    }
  }
};
</script>

<style>
</style>
